<template>
  <v-app id="app">
    <navigation-drawer v-if="isNavigationVisible" />
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import NavigationDrawer from "./components/NavigationDrawer";
export default {
  name: "app",
  components: {
    NavigationDrawer
  },
  data() {
    return {};
  },
  computed: {
    isNavigationVisible() {
      return (
        this.$store.getters.isNavigationVisible === true &&
        this.$route.path === "/"
      );
    },
    isMobile() {
      return this.$route.path === "/mobile";
    }
  },
  methods: {
    //
  }
};
</script>

<style lang="scss">
#app {
  height: 100%;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow-y: hidden;
}
img {
  image-rendering: -webkit-optimize-contrast;
  image-rendering: pixelated;
  -ms-interpolation-mode: nearest-neighbor;
  image-rendering: -moz-crisp-edges;
  image-rendering: -o-crisp-edges;
  image-rendering: crisp-edges;
}
::-webkit-scrollbar {
  display: none;
}
::-webkit-scrollbar {
  width: 0px;
}
.v-snack.v-snack--active.v-snack--bottom {
  z-index: 5000;
}
.leaflet-bottom.leaflet-right {
  .leaflet-control-attribution.leaflet-control {
    pointer-events: painted !important;
  }
}
.v-dialog__content.v-dialog__content--active,
.v-overlay.v-overlay--active {
  z-index: 1001 !important;
}
</style>
